import buttonAs from './button_as';
export var ButtonLink = buttonAs('a');
export default buttonAs('button');
export { default as buttonAs } from './button_as';